import * as React from "react";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { Button } from "primereact/button";
import DropdownApi from "../../components/DropdownApi";
import {
  addClientAdmin,
  updateClientAdmin,
} from "../../service/employeeService";
import { Grid } from "@mui/material";

export default function ClientAdminAddView(modalProps: any) {
  const record = modalProps.record;

  const clientId = modalProps?.clientId;

  async function EmployeeAdd() {
    let createObject: any = {
      client_id: clientId,
      employee_id:employee
      // access_level: accessLevel
    };
    modalProps.setGlobalLoading(true);
    if (record?.id) {
      updateClientAdmin(createObject, record.id).then((r: any) => {
        modalProps.setGlobalLoading(false);
        modalProps.toast.current.show({
          severity: "success",
          summary: "Admin Updated Successfully",
          life: 3000,
        });
        modalProps.setReload(!modalProps.reload);
        modalProps.setVisible(false);
      });
      return;
    }
    addClientAdmin(createObject).then((r: any) => {
      modalProps.setGlobalLoading(false);
      modalProps.toast.current.show({
        severity: "success",
        summary: "Admin Added Successfully",
        life: 3000,
      });
      modalProps.setReload(!modalProps.reload);
      modalProps.setVisible(false);
    });
  }

  const [employee, setEmployee] = React.useState(record?.employee_id || "");
  // const [accessLevel, setAccessLevel] = React.useState(
  //   record?.access_level || ""
  // );

  return (
    <React.Fragment>
      <br />
      <Grid container spacing={2}>
      <Grid item xs={12}>
          <DropdownApi
            apiPath="employee"
            optionLabel="full_name"
            optionValue="id"
            label="Employee"
            selectedData={employee}
            setSelectedData={setEmployee}
          />
        </Grid>
      </Grid>
      <br />

      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions
          style={{ marginTop: 15 }}
          sx={{ alignSelf: "flex-end", pt: 2 }}
        >
          <Button
            type="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => EmployeeAdd()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
